export const FrenchFlag = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0 0h640v480H0z" fill="#fff" />
      <path d="M0 0h213.3v480H0z" fill="#000091" />
      <path d="M426.7 0H640v480H426.7z" fill="#e1000f" />
    </svg>
  );
};
